import styled from 'styled-components';
import { H4Styles } from '../Text/H4';
import { NavigationStyles } from '../Text/Navigation';

export const Container = styled.div`
  @supports (-webkit-touch-callout: none) {
  /* CSS specific to iOS devices */ 
  width: ${props => props._secondary ? '-webkit-calc(100% - 2px)' : '100%'};
  }
  width: ${props => props._secondary ? 'calc(100% - 2px)' : '100%'};
  max-width: 335px;
  min-height: ${props => props.minimal ? '14px' : '50px'};
  display: flex;
  justify-content: center;
  position: relative;
  align-items: center;
  border-radius: 2px;
  cursor: pointer;
  border: ${props => props.minimal ? 'none' : props._secondary ? `1px solid ${props.theme['primary-color']}` : 'none'};
  background-color: ${props => props.minimal ? 'transparent' : props._secondary ? 'white' : props.danger ? '#EA3250' : props.theme['primary-color']};
`;

export const Label = styled(H4Styles)`
  width: 90%;
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  color: ${props =>
    props._secondary ? props.theme['primary-color'] : '#FFFFFF'};
  text-align: center;
  pointer-events: none;
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer */
  -khtml-user-select: none; /* KHTML browsers (e.g. Konqueror) */
  -webkit-user-select: none; /* Chrome, Safari, and Opera */
  -webkit-touch-callout: none; /* Disable Android and iOS callouts*/
  margin: auto;
`;


export const LabelMinimal = styled(NavigationStyles)`
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  color: ${props => props.theme['text-color']};
  text-align: center;
  pointer-events: none;
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer */
  -khtml-user-select: none; /* KHTML browsers (e.g. Konqueror) */
  -webkit-user-select: none; /* Chrome, Safari, and Opera */
  -webkit-touch-callout: none; /* Disable Android and iOS callouts*/
  margin: auto;
`;
